<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-28 15:27:28
 * @LastEditors: Liu ShuaiBo
 * @LastEditTime: 2021-10-28 18:04:55
-->
<template>
    <el-upload
      :accept="accept"
      :http-request="upload"
      :show-file-list="false"
      :multiple="false"
      action="no"
    >
      <slot></slot>
    </el-upload>
</template>
<script>
    export default {
        name: "UploadFile",
        props: {
          accept: {
            type: String,
            default: '*'
          }
        },
        methods: {
          upload(val) {
            const formData = new FormData();
            formData.append('file', val.file);
            this.$emit('upload', formData);
          }
        }
    }
</script>

<style scoped lang="less">

</style>